import { ref, computed } from 'vue';
import currency from 'currency.js';

export function useTripStats(activeTrip) {
    const isPopoverOpen = ref({
        popover1: false,
        popover2: false,
        popover3: false,
    });

    const formatCurrency = (amount) => {
        if (amount == null) {
            return '$0.00';
        }
        return currency(amount, { symbol: '$', precision: 2 }).format();
    };

    const formatNumber = (number) => {
        return Intl.NumberFormat('en-US').format(number);
    };

    const cdnUrl = computed(() => {
        return window.cdnUrl;
    });

    const totalValue = computed(() => {
        return (
            parseFloat(activeTrip.value?.taxes_value ?? 0) +
            parseFloat(activeTrip.value?.cash_value ?? 0)
        );
    });

    const cashSpentTotal = computed(() => {
        return (
            parseFloat(activeTrip.value?.cash_spend_value ?? 0) +
            parseFloat(activeTrip.value?.cash_spend_taxes_value ?? 0)
        );
    });

    const computedPointsPrograms = computed(() => {
        return activeTrip.value?.payment_points_detail?.reduce(
            (arr, redemption) => {
                const programIndex = arr.findIndex(
                    (item) =>
                        item.payment_program_id == redemption.payment_program_id
                );
                if (programIndex === -1) {
                    arr.push({
                        payment_program: redemption.payment_program,
                        payment_points: redemption.payment_points,
                        payment_program_id: redemption.payment_program_id,
                    });
                } else {
                    arr[programIndex].payment_points +=
                        redemption.payment_points;
                }
                return arr;
            },
            []
        );
    });

    const togglePopover = (popover) => {
        Object.keys(isPopoverOpen.value).forEach((key) => {
            isPopoverOpen.value[key] = false;
        });
        isPopoverOpen.value[popover] = !isPopoverOpen.value[popover];
    };

    const closePopover = (popover) => {
        isPopoverOpen.value[popover] = false;
    };

    return {
        formatCurrency,
        formatNumber,
        cdnUrl,
        totalValue,
        cashSpentTotal,
        computedPointsPrograms,
        isPopoverOpen,
        togglePopover,
        closePopover,
    };
}
